import {all, takeEvery, takeLatest, put, fork, call} from 'redux-saga/effects';
import {push} from 'react-router-redux';
import {getToken, clearToken} from '../../../helpers/utility';
import actions from './actions';
import {doLogin, authenticateUser, postUser, postPassRequest} from '../../../api/auth/auth';
import {Axios_Instance} from '../../../api/base.js';
import jwtDecode from 'jwt-decode';
import { ungzip, gzip } from 'node-gzip';
import _ from 'lodash';
function* createUser(user) {
  try {
    const response = yield call(postUser, user);
    if (response.user) {
      yield put({type: actions.SIGN_UP_SUCCESS});
      yield put(push('/'));
    } else {
      yield put({type: actions.SIGN_UP_ERROR});
    }
  } catch (error) {
    yield put({type: actions.SIGN_UP_ERROR});
  }
}

async function unGzipData(data){
  try {
    data.token = (await ungzip(Buffer.from(data.token, 'base64'))).toString();
    return data;
  } catch (e) {
    return "";
  }
}

function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST',  function* (payload) {
    try {
      const response = yield call(doLogin, payload.credentials.email, payload.credentials.password);
      if (response.id_token) {
        let data =  yield call(authenticateUser, response.id_token);
        data = yield unGzipData(data);
        if (data.token) {
          const user = yield jwtDecode(data.token);
          if (data.token) {
            yield put({
              type: actions.LOGIN_SUCCESS,
              token: data.token,
              user: user.user,
            });
          }
        } else {
          yield put({type: actions.LOGIN_ERROR, message: data[0].message});
        }
      } else {
        yield put({type: actions.LOGIN_ERROR, message: response[0].message});
      }
    } catch (e) {
      yield put({type: actions.LOGIN_ERROR, message: 'An unexpected error occurred. Please try again later.'});
    }
  });
}

async function gzipData(data){
  data.token = (await gzip(_.clone(data).token, { level: 8 })).toString("base64");
  return data;
}

function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {

    const idToken =  yield gzipData(_.clone(payload));
    localStorage.setItem('id_token', idToken.token);
    yield Axios_Instance.defaults.headers = {
      Authorization: 'Bearer ' + getToken().get('idToken'),
    };
    if (!payload.check) {
      yield all([
        put({type: actions.LOGIN_FINISHED}),
        put(push('/dashboard/')),
      ]);
    }
  });
}

function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    clearToken();
    yield put(push('/'));
  });
}
function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const idToken = getToken().get('idToken');
    const data = yield unGzipData({token: idToken})
    if (idToken || data) {
      const user = yield jwtDecode(data ? data.token : idToken);
      yield put({
        type: actions.LOGIN_SUCCESS,
        check: true,
        token: data.token,
        user: user ? user.user : null,
      });
    } else {
      clearToken();
      yield put(push('/'));
    }
  });
}

function* sendPasswordRequest(payload) {
  try {
    const response = yield call(postPassRequest, payload.email);
    if (response.emailSent) {
      yield put({type: actions.FORGOT_PASSWORD_SUCCESS, message: 'We\'ve sent you an email with a link to reset your password.'});
    } else {
      yield put({type: actions.FORGOT_PASSWORD_ERROR, message: response[0].message});
    }
  } catch (error) {
    yield put({type: actions.FORGOT_PASSWORD_ERROR, message: 'An unexpected error occurred. Please try again later.'});
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.USER_SIGN_UP, createUser),
    takeLatest(actions.FORGOT_PASSWORD, sendPasswordRequest),
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(logout)
  ]);
}
